import { SemanticType as R } from "../../../MetaModel.js";
var L = /* @__PURE__ */ ((E) => (E.VALUE_LIST = "valueList", E.PATTERN = "pattern", E.SCALAR = "scalar", E.RANGE = "range", E))(L || {}), T = /* @__PURE__ */ ((E) => (E.negate = "negate", E.default = "default", E))(T || {}), A = /* @__PURE__ */ ((E) => (E.CHART = "CHART", E.QUERY = "QUERY", E))(A || {}), _ = /* @__PURE__ */ ((E) => (E.IN = "In", E.Like = "Like", E.Match = "Match", E.BETWEEN = "BETWEEN", E.GT = "GT", E.GTE = "GTE", E.LT = "LT", E.LTE = "LTE", E.EQ = "EQ", E))(_ || {}), L = /* @__PURE__ */ ((E) => (E.dimension = "dimension", E.metric = "metric", E))(L || {}), N = /* @__PURE__ */ ((E) => (E.VALUE_SELECTION = "VALUE_SELECTION", E.INCLUDE = "INCLUDE", E.START_WITH = "START_WITH", E.END_WITH = "END_WITH", E.REGEX = "REGEX", E.GREATER = "GREATER", E.GREATER_OR_EQ = "GREATER_OR_EQ", E.LOWER = "LOWER", E.LOWER_OR_EQ = "LOWER_OR_EQ", E.BETWEEN = "BETWEEN", E.EQUAL = "EQUAL", E))(N || {});
const U = {
  [R.STRING]: [
    "VALUE_SELECTION",
    "INCLUDE",
    "START_WITH",
    "END_WITH",
    "REGEX"
    /* REGEX */
  ],
  [R.NUMBER]: [
    "VALUE_SELECTION",
    "GREATER",
    "GREATER_OR_EQ",
    "LOWER",
    "LOWER_OR_EQ",
    "BETWEEN"
    /* BETWEEN */
  ],
  [R.DATE]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  [R.UUID]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  [R.DATETIME]: [
    "VALUE_SELECTION"
    /* VALUE_SELECTION */
  ],
  metric: [
    "GREATER",
    "GREATER_OR_EQ",
    "LOWER",
    "LOWER_OR_EQ",
    "EQUAL",
    "BETWEEN"
    /* BETWEEN */
  ]
};
export {
  N as FilterInputType,
  U as FilterInputTypeBySemanticType,
  T as FilterNegationType,
  _ as FilterOperator,
  L as FilterType,
  A as Source
};
//# sourceMappingURL=filters.js.map
